import { render, staticRenderFns } from "./ConfirmationsReport.vue?vue&type=template&id=0af4c580&lang=html&"
import script from "./ConfirmationsReport.vue?vue&type=script&lang=js&"
export * from "./ConfirmationsReport.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationsReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAutocomplete,VChip,VFlex,VLayout,VSelect})
